import { Outlet } from 'react-router';
import { ThemeProvider } from '@mui/material/styles';
import { muiTheme } from '../utils/muiTheme';

function RootLayout() {
  return (
    <ThemeProvider theme={muiTheme}>
      <Outlet />
    </ThemeProvider>
  );
}

export default RootLayout;
